import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { AlteracaoCadastralService } from '@/core/api/sicom-api/servicos/pessoa-juridica/alteracao-cadastral/alteracao-cadastral.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { AlteracaoCadastralRequest, AlteracaoCadastralResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/alteracao-cadastral/alteracao-cadastral.model';

@Injectable({ providedIn: 'root' })
export class AlteracaoCadastralPjServicosService {
    constructor(
        private api: AlteracaoCadastralService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: AlteracaoCadastralRequest, context?: HttpContext): Observable<AlteracaoCadastralResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
